import { render } from "./MypageFavoriteFoodsPage.vue?vue&type=template&id=2f4d9d62&scoped=true&ts=true"
import script from "./MypageFavoriteFoodsPage.vue?vue&type=script&lang=ts"
export * from "./MypageFavoriteFoodsPage.vue?vue&type=script&lang=ts"

import "./MypageFavoriteFoodsPage.vue?vue&type=style&index=0&id=2f4d9d62&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4d9d62"]])

export default __exports__